var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h4',[_c('small',[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}},[_vm._v(" "+_vm._s(_vm.plant)+" ")]),_vm._v(" "),_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a6d1641","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Charts/ReincidenciaChart.vue
// module id = qbTh
// module chunks = 6